import React from 'react';
import spacetime from 'spacetime';
import Toast from '@fff-web/fff-ui-shared/Toast';
import usePreviewCustomizeTimer from './usePreviewCustomizeTimer';
import Timer from './Timer';
import styles from './TimerBar.module.scss';

type Props = {
  viewSize: string,
  timerStarted: boolean,
};

const TimerBar = (props: Props) => {
  const { timerStarted, viewSize } = props;
  let timer = window.localStorage.getItem('endTimer');
  if (!timer && timerStarted) {
    timer = usePreviewCustomizeTimer().endTime;
    if (timer) {
      window.localStorage.setItem('endTimer', timer);
    }
  }
  const endTime = spacetime(`${timer}Z`);

  return (
    <div className={`${styles.timerBar} ${styles[viewSize]}`}>
      <div className={styles.content}>
        <i className="far fa-shipping-fast" />
        <p className={styles.info}>Check out within 5 minutes to lock in your product choices.</p>
        {timer && endTime && (
        <Timer
          expDate={new Date(endTime.format('iso-utc'))}
          viewSize={viewSize}
        />
        )}
      </div>
      <Toast autoClose={false} />
    </div>
  );
};

export default TimerBar;
